import React from 'react';
import { inject, observer } from 'mobx-react';
import ChatIconSrc from './chat-icon.svg';
import * as S from './styled';

export const CustomFreshChatBtn = inject('ProfileStore')(
  observer(
    ({ ProfileStore, ...restProps }) =>
      ProfileStore.isInitedFreshChat && (
        <S.Chat
          onClick={() => {
            window.fcWidget.open();
          }}
          {...restProps}
        >
          <img src={ChatIconSrc} alt="" />
        </S.Chat>
      )
  )
);
